import { Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptimizedImage, NgStyle } from '@angular/common';

@Component({
  selector: 'app-image-viewer',
  imports: [FormsModule, NgStyle, NgOptimizedImage],
  templateUrl: './image-viewer.component.html',
  styleUrl: '../../../../static/styles/components/image-viewer.component.scss',
})
export class ImageViewerComponent {
  url = input<string>(''); // Default to empty string

  zoom = 100;
  readonly ZOOM_STEP = 10;
  readonly MIN_ZOOM = 10;
  readonly MAX_ZOOM = 300;

  // Rotation state (degrees)
  rotation = 0;
  readonly ROTATION_STEP = 90;

  // Error state
  imageError = false;
  errorMessage = '';

  // Computed transform string
  get transformStyle(): string {
    const scale = this.zoom / 100;
    return `scale(${scale}) rotate(${this.rotation}deg)`;
  }

  zoomIn(): void {
    if (this.zoom < this.MAX_ZOOM) {
      this.zoom += this.ZOOM_STEP;
    }
  }

  zoomOut(): void {
    if (this.zoom > this.MIN_ZOOM) {
      this.zoom -= this.ZOOM_STEP;
    }
  }

  rotateClockwise(): void {
    this.rotation = (this.rotation + this.ROTATION_STEP) % 360;
  }

  rotateCounterClockwise(): void {
    this.rotation = (this.rotation - this.ROTATION_STEP + 360) % 360;
  }

  resetView(): void {
    this.zoom = 100;
    this.rotation = 0;
  }

  onImageLoad(): void {
    this.imageError = false;
    this.errorMessage = '';
  }

  onImageError(): void {
    this.imageError = true;
    this.errorMessage = 'Failed to load image. The file may be inaccessible or corrupted.';
  }
}
